import SCHCTemplatesManageDataMainSection from './SCHCTemplatesManageDataMainSection';

export default SCHCTemplatesManageDataMainSection;
